import gql from 'graphql-tag';

export const getFacility = gql`
  query getFacility($id: String) {
    getFacility(id: $id) {
      id
      ContactListId
      managementContactListId
      Locations {
        id
        state
        county
        township
      }
      businessUnit {
        id
        name
      }
      address
      facilityName
      facilityUid
      FacilityType {
        id
        name
      }
      AORs {
        id
        name
        isPrimary
      }
      Company {
        id
        name
      }
      NotepadEntries {
        id
        categoryId
        note
        archived
        createdBy
        createdAt
        updater
        updatedAt
        Category {
          id
          name
        }
      }
      notes
      phone
      altPhone
      gps
      scadaId
      flocNumber
      timezone
      updater
      deletedAt
      version
      hidden
      autoSignout
      area {
        id
        name
        region {
          id
          name
        }
      }
      owner {
        id
        firstName
        lastName
        nickName
      }
      AdditionalResourceLists {
        id
        name
        ContactListMembers {
          id
          order
          Contact {
            id
            firstName
            lastName
            nickName
            adAccountName
            otherPhone
            speedDial
            businessMobile
            businessPhone
            afterHoursPhoneNumber
            home
            other
            personalMobile
            Company {
              id
              name
              abbreviation
              version
            }
            WhenUnavailable {
              id
              firstName
              lastName
            }
            JobRole {
              id
              name
            }
            ReportsTo {
              id
              firstName
              lastName
              businessMobile
              ReportsTo {
                id
                firstName
                lastName
                businessMobile
              }
              version
            }
          }
        }
        AdditionalResourceListType {
          id
          name
          enabled
        }
      }
    }
  }
`;
